export const cartActionTypes = {
  TOGGLE_CART: "TOGGLE_CART",
  ADD_ITEM: "ADD_ITEM",
  REMOVE_ITEM: "REMOVE_ITEM",
  SUBTRACT_ITEM: "SUBTRACT_ITEM",
};
